module.exports = __webpack_public_path__ + "img/1554709306.c901ab9f.jpg";